module.exports = __webpack_public_path__ + "img/lectorami.f23f9526.png";